<template lang="html">
  <div class="nav-background-wrapper">
    <div v-if="windowWidth > 1000" class="nav-wrapper">
      <div class="up">
        <div class="logo-wrapper">
          <router-link :to="{ name: 'Home', params: { lang: $i18n.locale } }">
            <img src="@/assets/newImges/new-logo.png" alt="logo image" />
          </router-link>
        </div>

        <search-dropdown
          style="flex-grow: 1; padding: 0 30px;"
          :full-width="false"
        />
        <div class="up-right">
          <locale-picker />
          <template v-if="!userIsLoged">
            <div class="btn dark-blue" @click="openSignInModal">
              {{ $t("main.login") }}
            </div>
            <div class="btn dark-blue outlined" @click="openRegisterModal()">
              {{ $t("main.registration") }}
            </div>
          </template>
          <template v-else>
            <router-link
              class="btn dark-blue"
              v-if="userIsLoged"
              :to="{ name: 'NewAd', params: { lang: $i18n.locale } }"
            >
              {{ $t("profile.purchase.newSale") }}
            </router-link>
            <router-link
              :to="{ name: 'Profile', params: { lang: $i18n.locale } }"
            >
              {{ $t("nav.profile") }}
              <notification-counter
                v-if="allNotificationsCount"
                :counter="allNotificationsCount"
              />
            </router-link>
            <div class="wish-list-wrapper">
              <router-link
                tag="div"
                :to="{ name: 'Favorites', params: { lang: $i18n.locale } }"
              >
                <div class="icon-wrapper">
                  <img src="@/assets/icons/wishList.png" alt="favorite icon" />
                  <notification-counter
                    v-if="favoritesLength"
                    :counter="favoritesLength"
                  />
                </div>
              </router-link>
              <router-link
                :to="{ name: 'Favorites', params: { lang: $i18n.locale } }"
                >{{ $t("nav.wishList") }}</router-link
              >
            </div>
            <span @click="logout()" class="logout">{{ $t("nav.logout") }}</span>
          </template>
        </div>
      </div>
      <div class="down">
        <div class="cluster">
          <router-link
            :to="{ name: 'Buyers', params: { lang: $i18n.locale } }"
            >{{ $t("nav.buyers") }}</router-link
          >
          <router-link
            :to="{ name: 'Sellers', params: { lang: $i18n.locale } }"
            >{{ $t("nav.sellers") }}</router-link
          >
          <router-link
            :to="{ name: 'Franchise', params: { lang: $i18n.locale } }"
            >{{ $t("nav.franchise") }}</router-link
          >
        </div>
        <div class="cluster">
          <router-link
            :to="{ name: 'Berza', params: { lang: $i18n.locale } }"
            >{{ $t("nav.berza") }}</router-link
          >
          <router-link
            :to="{ name: 'Rules', params: { lang: $i18n.locale } }"
            >{{ $t("nav.rules") }}</router-link
          >
          <router-link :to="{ name: 'Faq', params: { lang: $i18n.locale } }">{{
            $t("nav.faq")
          }}</router-link>
          <router-link :to="{ name: 'News', params: { lang: $i18n.locale } }">{{
            $t("nav.news")
          }}</router-link>
        </div>
      </div>
    </div>
    <!------        izmena ------------>
    <div v-else class="small-nav-wrapper">
      <slide
        :isOpen="slideIsOpen"
        @openMenu="openSlide"
        @closeMenu="closeSlide"
        noOverlay
        :closeOnNavigation="false"
      >
        <div class="locPic">
          <div class="logo-wrapper">
            <router-link
              @click="closeSlide()"
              :to="{ name: 'Home', params: { lang: $i18n.locale } }"
            >
              <img src="@/assets/newImges/new-logo.png" alt="logo image" />
            </router-link>
          </div>
          <locale-picker :blackDiv="false" />
        </div>
        <!-- <search-dropdown @search="closeSlide()" :blackDiv="false" /> -->
        <div class="links-wrapper">
          <div @click="closeSlide()" class="single-link">
            <router-link
              :to="{ name: 'Buyers', params: { lang: $i18n.locale } }"
            >
              {{ $t("nav.buyers") }}
            </router-link>
          </div>
          <div @click="closeSlide()" class="single-link">
            <router-link
              :to="{ name: 'Sellers', params: { lang: $i18n.locale } }"
            >
              {{ $t("nav.sellers") }}
            </router-link>
          </div>
          <div @click="closeSlide()" class="single-link">
            <router-link
              :to="{ name: 'Franchise', params: { lang: $i18n.locale } }"
            >
              {{ $t("nav.franchise") }}
            </router-link>
          </div>
          <div class="border"></div>
          <!-- <div class="single-link">
            <router-link :to="{ name: 'About', params: { lang: $i18n.locale } }">{{$t('nav.competitions')}}</router-link>
          </div> -->
          <div @click="closeSlide()" class="single-link">
            <router-link
              :to="{ name: 'Berza', params: { lang: $i18n.locale } }"
              >{{ $t("nav.berza") }}</router-link
            >
          </div>
          <div @click="closeSlide()" class="single-link">
            <router-link
              :to="{ name: 'Rules', params: { lang: $i18n.locale } }"
              >{{ $t("nav.rules") }}</router-link
            >
          </div>
          <div @click="closeSlide()" class="single-link">
            <router-link
              :to="{ name: 'Faq', params: { lang: $i18n.locale } }"
              >{{ $t("nav.faq") }}</router-link
            >
          </div>
          <div @click="closeSlide()" class="single-link">
            <router-link
              :to="{ name: 'News', params: { lang: $i18n.locale } }"
              >{{ $t("nav.news") }}</router-link
            >
          </div>
          <div @click="closeSlide()" v-if="userIsLoged" class="single-link">
            <router-link
              :to="{ name: 'Profile', params: { lang: $i18n.locale } }"
            >
              {{ $t("nav.profile") }}
              <notification-counter
                v-if="allNotificationsCount"
                :counter="allNotificationsCount"
              />
            </router-link>
          </div>
          <div
            @click="closeSlide()"
            v-if="userIsLoged && favoritesLength"
            class="single-link"
          >
            <router-link
              tag="div"
              :to="{ name: 'Favorites', params: { lang: $i18n.locale } }"
            >
              <div class="icon-wrapper">
                <img src="@/assets/icons/wishList.png" alt="favorite icon" />
                <notification-counter
                  v-if="favoritesLength"
                  :counter="favoritesLength"
                />
              </div>
            </router-link>
          </div>
        </div>
        <div class="border-wrap">
          <div class="border">
            <!--   <login-dropdown
            v-if="!userIsLoged"
            :userIsLoged="userIsLoged"
            @changeLoged="$emit('changeLoged', $event)"
          />
          -->
            <div
              class="single-link"
              v-if="!userIsLoged"
              @click="openSignInModal(), closeSlide()"
            >
              {{ $t("main.login") }}
            </div>
            <div v-else class="logout-wrapper1">
              <div @click="closeSlide()">
                <span @click="logout()" class="logout">{{
                  $t("nav.logout")
                }}</span>
              </div>
              <div @click="closeSlide()">
                <router-link
                  tag="span"
                  v-if="userName"
                  class="user-name"
                  :to="{ name: 'Profile', params: { lang: $i18n.locale } }"
                  >{{ userName }}
                </router-link>
              </div>
            </div>
            <div
              v-if="!userIsLoged"
              @click="openRegisterModal(), closeSlide()"
              class="single-link"
            >
              <a>{{ $t("nav.register") }}</a>
            </div>
          </div>
        </div>
        <!-- <categories :categories="categories" @changeCategory="changeCategory"/> -->
      </slide>
      <div class="nav-content">
        <div class="search-icon">
          <img
            src="@/assets/newImges/icons/search.svg"
            alt="search"
            @click="searchVisible = !searchVisible"
            style="width: 32px; height: auto; cursor: pointer"
          />
        </div>
        <div class="logo-wrapper">
          <router-link
            @click="closeSlide()"
            :to="{ name: 'Home', params: { lang: $i18n.locale } }"
          >
            <img src="@/assets/newImges/new-logo.png" alt="logo image" />
          </router-link>
        </div>
      </div>
    </div>
    <transition tag="div" name="fade-in">
      <div class="t-overlay" v-if="slideIsOpen">
        <img
          src="@/assets/newImges/icons/close-icon.svg"
          alt="close"
          @click="closeSlide"
        />
      </div>
    </transition>
    <transition name="fade-in">
      <div
        class="nav-search-dropdown"
        v-if="searchVisible && windowWidth < 1000"
      >
        <search-dropdown :full-width="true" @search="searchVisible = false" />
      </div>
    </transition>
  </div>
</template>

<script>
import { Slide } from "vue-burger-menu";
import LocalePicker from "@/components/header/LocalePicker.vue";
import SearchDropdown from "@/components/header/SearchDropdown.vue";
// import Categories from '@/components/topSection/categories.vue'
import NotificationCounter from "@/components/notificationCounter.vue";
import eventBus from "@/shared/eventBus.js";
import { api } from "@/api";
import { mapState } from "vuex";

export default {
  name: "Navigation",
  props: {
    userIsLoged: {
      type: Boolean,
      required: true
    },
    windowWidth: {
      required: false,
      type: Number
    }
  },
  components: {
    LocalePicker,
    SearchDropdown,
    Slide,
    // Categories,
    NotificationCounter
  },
  data() {
    return {
      categories: [],
      slideIsOpen: false,
      searchVisible: false,
      selectedIcon: null
    };
  },
  mounted() {
    this.$store.commit("changeFavoritesLength");
    this.getCategories();
  },
  methods: {
    test(item) {
      console.log(item);
    },
    openSlide() {
      this.slideIsOpen = true;
    },
    closeSlide() {
      this.slideIsOpen = false;
    },
    logout() {
      eventBus.$emit("logout");
      api
        .logout()
        .then(res => {
          localStorage.removeItem("sid");
          this.$emit("changeLoged", false);
          this.$store.commit("setUserName", null);
          this.$store.commit("setUserImage", null);
          this.$store.commit("setDisplayName", null);
          this.$store.commit("setUserAdmin", false);
          this.$store.commit("closeWSConnection");
          if (this.$route.name !== "Home") {
            this.$router.push({
              name: "Home",
              params: { lang: this.$i18n.locale }
            });
          }
          window.location.reload();
        })
        .catch(e => {
          console.log(e);
        });
    },
    openRegisterModal() {
      eventBus.$emit("openModal", { component: "chooseRegistrationModal" });
    },
    openSignInModal() {
      let params = {
        modalData: { userIsLoged: this.userIsLoged },
        component: "signInMod"
      };
      eventBus.$emit("openModal", params);
    },
    changeCategory(category) {
      const query = {
        category: category.cat_id
      };
      this.$router.push({
        name: "Result",
        params: this.$route.params,
        query: query
      });
    },
    getCategories() {
      api
        .getCategories()
        .then(res => {
          for (var i = 0; i < res.data.data.length; i++) {
            res.data.data[i].open = false;
          }
          this.categories = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    }
  },
  computed: {
    ...mapState(["userName", "favoritesLength", "allNotificationsCount"]),
    getActive() {
      return str => {
        let page = this.$route.name;
        if (str === page) {
          return true;
        }
        return false;
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-background-wrapper {
  width: 100%;
  background-color: white;
  position: sticky;
  top: 0px;
  z-index: 2;
  // height: 90px;
  // box-shadow: 0px 3px 14px rgba(0, 0, 0, 0.06);
  @media screen and (max-width: 1000px) {
    height: 90px;
  }

  .nav-wrapper {
    max-width: 1320px;
    width: calc(100% - 40px);
    margin: 0 auto;
    height: 100%;
    white-space: nowrap;
    .up {
      display: flex;
      justify-content: space-between;
      gap: 20px;
      align-items: center;
      width: 100%;
      height: 90px;
      border-bottom: 1px solid $gray-1100;
      .logo-wrapper {
        img {
          width: 150px;
        }
      }
      .up-right {
        display: flex;
        gap: 25px;
        align-items: center;
        a {
          font-size: 18px;
          letter-spacing: 0.02em;
          text-decoration: none;
          color: $text-color;
          white-space: nowrap;
          &.router-link-active {
            text-decoration: underline;
          }
          &.btn {
            color: $white;
            text-decoration: none;
          }
        }
        .btn {
          padding: 10px 20px;
        }
        .wish-list-wrapper {
          position: relative;
          display: flex;
          gap: 5px;
          align-items: center;
        }
      }
    }
    .down {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 90px;
      .cluster {
        display: flex;
        gap: 10px;
        justify-content: space-between;
        width: max(20%, 300px);
        a {
          font-size: 18px;
          letter-spacing: 0.02em;
          text-decoration: none;
          color: $text-color;
          white-space: nowrap;
          &.router-link-active {
            text-decoration: underline;
          }
        }
      }
      // height: 100%;s
    }
  }
  .small-nav-wrapper {
    height: 100%;
    width: calc(100% - 40px);

    // gap: 16px;
    margin: 0 auto;
    // padding-left: 60px;
    position: relative;
    // justify-content: flex-start;
    .nav-content {
      width: calc(100% - 60px);
      padding-left: 60px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
    }

    .logo-wrapper {
      img {
        width: 150px;
      }
    }

    .logout {
      cursor: pointer;
      // color: #ffffff;
      opacity: 0.5;
    }

    .single-link a {
      cursor: pointer;
    }
    .links-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      // margin-left: 10px;

      .single-link {
        margin-bottom: 20px;
        position: relative;

        a {
          font-size: 18px;
          letter-spacing: 0.02em;
          text-decoration: none;
          color: $text-color;
          white-space: nowrap;
          &.router-link-active {
            text-decoration: underline;
          }
        }
      }
      .single-link:hover {
        transform: scale(1.1);
        // color: $text-hover-color;
      }
    }

    .categories-wrapper {
      background: white;
      height: 300px;
      min-width: auto;
      display: flex;
      flex-direction: column;

      .categories {
        position: relative !important;
      }
    }
  }
}
.logout-wrapper1 {
  width: 100%;
  display: flex;
  justify-content: space-between !important;
  font-family: Ubuntu;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 15px;
  /* identical to box height */

  letter-spacing: 0.02em;

  // color: #ffffff;
}
.nav-search-dropdown {
  padding: 0 10px;
}
a {
  position: relative;
}
.logout {
  cursor: pointer;
}
</style>
<style lang="scss">
.nav-background-wrapper {
  .bm-burger-button {
    left: 20px;
    top: 32px;
    height: 20px;
    width: 25px;
  }
}
.bm-burger-bars {
  border-radius: 10px;
  background: $blue-900;
  &:nth-child(2) {
    left: 20%;
    right: -20%;
  }
}
.bm-cross-button.cross-style {
  display: none;
}
.bm-menu {
  // box-sizing: border-box;
  top: 0px;
  left: 0px;
  padding-top: 0;
  // position: relative;
  // padding: 30px 10px 0 10px;
  background-color: $white !important;
  color: $text-color;
}
.bm-item-list {
  position: relative;
  //height: 50vh;
  background-color: $white;
  color: $text-color;
  // padding-top: 30px;
  margin-left: 10px;
}
.locPic {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 23px 0;
  border-bottom: 1px solid $gray-1100;
  width: 90%;
  margin-left: 10px;

  .picker-wrapper {
    margin-bottom: 0 !important;
  }
}
.bm-menu {
  .border-wrap {
    padding-left: 0.7rem;
  }
  .border {
    width: 95%;
    box-sizing: border-box;
    // background-color: $white;
    // position: fixed;
    // bottom: 100px;
    border-top: 1px solid $gray-1100;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between !important;
  }
}
.bm-overlay {
  background: #193965;
  z-index: 1000;
}
.t-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(25, 57, 101, 0.8);
  z-index: 999;
  img {
    height: 20px;
    width: 20px;
    position: absolute;
    z-index: 1010;
    right: 20px;
    top: 30px;
    cursor: pointer;
  }
}
</style>
